export default __webpack_public_path__ + "assets/static/data/blog-data.f91153dc1917581745e3012dfe116280.json";